module.exports = __webpack_public_path__ + "img/78.7852a4a6.jpg";